/**
 * Preview HTML generator — generates a self-contained HTML preview
 * All CSS and JS are inlined (no external files)
 */
import { esc } from '@/utils/escape';
import { generateTokensCSS } from '../css/tokens';
import { generateComponentsCSS } from '../css/components';
import { generateMainJS } from '../js/main';
import { generateBodyContent } from '../html/page';

export function generatePreviewHTML(components: any, order: string[], settings: any): string {
  const tokensCSS = generateTokensCSS(settings);
  const componentsCSS = generateComponentsCSS();
  const mainJS = generateMainJS(settings, components);
  const bodyHTML = generateBodyContent(components, order, settings);

  // Build Premium FX class list
  const fxClasses = ['preview-root'];
  if (settings.darkMode) fxClasses.push('dark');
  if (settings.fontStack && settings.fontStack !== 'system')
    fxClasses.push(`font-${settings.fontStack}`);
  const intensity = settings.fxIntensity || 'medium';
  if (settings.fxOrbs) fxClasses.push('fx-orbs', `fx-orbs-${intensity}`);
  if (settings.fxGrain)
    fxClasses.push('fx-grain', `fx-grain-${intensity}`);
  if (settings.fxGlass) fxClasses.push('fx-glass-cards');

  // Grain overlay element
  const grainOverlay = settings.fxGrain
    ? '\n  <div class="fx-grain-overlay" aria-hidden="true"></div>\n'
    : '';

  return `<!DOCTYPE html>
<html lang="de"${settings.darkMode ? ' class="dark"' : ''}>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="description" content="${esc(settings.siteDescription)}">
  <title>${esc(settings.siteName)}</title>
  <link rel="icon" href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>${settings.faviconEmoji}</text></svg>">
  <style>
${tokensCSS}

${componentsCSS}
  </style>
</head>
<body data-style="${settings.stylePreset || 'signature'}" data-density="${settings.designDensity || 'balanced'}" class="${fxClasses.join(' ')}">
  <a href="#main" class="skip-link">Zum Inhalt springen</a>
${grainOverlay}
  <!-- QA: B-1 -->
  <main id="main">
${bodyHTML}
  </main>

  <script>
${mainJS}
  <${'/'}script>
</body>
</html>`;
}
